/** Common slide wrapper. All slides use a warm cream background.
 *  `dark` is retained as a semantic prop — it now indicates an "accent"
 *  feature slide which gets a slightly stronger warm-gold gradient + sun glow. */
export default function SlideFrame({ children, dark = true, kicker, idx, total, footer = false, className = "" }) {
  return (
    <section
      data-testid={`slide-frame-${idx}`}
      className={`relative h-full w-full overflow-hidden text-ink-900 grain ${className}`}
      style={{
        background: dark
          ? "linear-gradient(135deg, #FDFBF5 0%, #FBF4DC 100%)"   // accent slides — cream → very pale gold
          : "linear-gradient(135deg, #FDFBF5 0%, #F9F5EB 100%)"   // info slides — straight cream gradient
      }}
    >
      {/* Ambient brand glow — visible on accent slides only */}
      {dark && (
        <>
          <div className="pointer-events-none absolute -top-40 -right-40 h-[560px] w-[560px] rounded-full blur-3xl opacity-[0.32]"
               style={{ background: "radial-gradient(circle, #F5B400 0%, transparent 65%)" }} />
          <div className="pointer-events-none absolute -bottom-44 -left-44 h-[480px] w-[480px] rounded-full blur-3xl opacity-[0.22]"
               style={{ background: "radial-gradient(circle, #FF7B1F 0%, transparent 70%)" }} />
        </>
      )}

      {/* Header */}
      <div className="relative z-10 flex items-center justify-between px-8 md:px-14 pt-6">
        <div className="flex items-center gap-3">
          <img
            src="/brand/complisun-mark.png"
            alt="CompliSun"
            className="h-10 w-10 object-contain"
            data-testid="brand-mark"
          />
          <span className="serif text-lg tracking-tight text-ink-900">CompliSun</span>
          {kicker && (
            <span className="mono text-[10px] uppercase tracking-[0.22em] ml-3 text-ink-900/50">
              · {kicker}
            </span>
          )}
        </div>
      </div>

      {/* Body */}
      <div className="relative z-10 h-[calc(100%-3.5rem)] overflow-y-auto">
        <div className="min-h-full px-8 md:px-14 pb-16 pt-6 md:pt-10">
          {children}
        </div>
      </div>

      {/* Footer */}
      {footer !== false && (
        <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-10 flex items-center justify-between px-8 md:px-14 py-5 mono text-[10px] uppercase tracking-[0.22em] text-ink-900/40">
          <span>Compliance Simplified</span>
          <span>complisunguardian.com</span>
        </div>
      )}
    </section>
  );
}
